import React from 'react';

function About({ language }) {
  const t = (en, id) => language === 'en' ? en : id;

  return (
    <div className="about-page">
      <div className="about-header">
        <h1>{t('About Us', 'Tentang Kami')}</h1>
        <p>PT Esawarna Gemilang</p>
      </div>

      <div className="about-content">
        <div className="about-description">
          <p>
            {t(
              'PT Esawarna Gemilang is engaged in the field of swimming pool consultant and contractor, waste/sewage treatment, and supplier of industrial factory, hotel and building needs, including:',
              'PT Esawarna Gemilang bergerak dibidang konsultan dan kontraktor swimming pool, waste/sewage dan supplier kebutuhan industri pabrik, hotel dan gedung, meliputi:'
            )}
          </p>
        </div>

        <div className="services-list about-services">
          <div className="service-item">
            <strong>1. Swimming Pool</strong>
            <p>{t(
              'Providing consultation services in mechanical and electrical construction for the construction, repair, and maintenance of swimming pools, whirlpool, Jacuzzi, sauna along with accessories and equipment.',
              'Memberikan jasa konsultasi dalam konstruksi mekanik elektrik untuk pembuatan, perbaikan, dan maintenance service swimming pool, whirlpool, Jacuzzi, sauna berikut aksesoris dan peralatannya.'
            )}</p>
          </div>

          <div className="service-item">
            <strong>2. Pretreatment / Water Treatment Plant</strong>
            <p>{t(
              'Consultation and water treatment systems, mechanical electrical for carbon filter, sand filter, softener, demineralizer, RO, UV.',
              'Memberikan jasa konsultasi dan system water treatment, mekanik elektrik untuk carbon filter, sand filter, softener, deminilizer, RO, UV.'
            )}</p>
          </div>

          <div className="service-item">
            <strong>3. Treatment Boiler</strong>
            <p>{t(
              'Maintenance services to prevent rust and scale in boilers and burner service.',
              'Memberikan jasa perawatan untuk mencegah karat dan kerak di boiler serta service burner.'
            )}</p>
          </div>

          <div className="service-item">
            <strong>4. Treatment Cooling Tower</strong>
            <p>{t(
              'Maintenance services to prevent scale and rust in heat exchanger.',
              'Memberikan jasa perawatan untuk mencegah kerak dan karat di heat exchanger.'
            )}</p>
          </div>

          <div className="service-item">
            <strong>5. Heatpump</strong>
            <p>{t(
              'For heating / cooling swimming pool and distributing cool air in rooms.',
              'Untuk pemanas / pendingin swimming pool serta mendistribusikan cool air di ruangan.'
            )}</p>
          </div>

          <div className="service-item">
            <strong>6. Sewage Treatment Plant</strong>
            <p>{t(
              'Consultation in construction, mechanical electrical, to overcome waste both chemically and biologically.',
              'Memberikan jasa konsultasi dalam konstruksi, mekanik elektrik, untuk mengatasi limbah baik secara kimiawi maupun secara bakteri/biologi.'
            )}</p>
          </div>

          <div className="service-item">
            <strong>7. Cleaning Chemical</strong>
            <p>{t(
              'a. Boiler & Cooling Tower scale/rust cleaner\nb. Aluminium coil, AHU, kitchen ducting & AC cleaner\nc. Housekeeping cleaner\nd. Sanitation cleaner\ne. Marble cleaner\nf. Metal contamination cleaner\ng. Ducting cleaning for restaurant, STP, AHU & FCU.',
              'a. Cleaning chemical untuk kerak dan karat boiler dan cooling tower.\nb. Cleaning chemical untuk alumunium coil, AHU, Ducting kitchen dan AC.\nc. Cleaning chemical untuk house keeping\nd. Cleaning chemical untuk sanitasi\ne. Cleaning chemical untuk marmet\nf. Cleaning chemical untuk kontaminasi pada metal yang bereaksi dan tidak bereaksi\ng. Pembuatan, pembersihan ducting untuk restaurant, intek STP, AHU dan FCU.'
            )}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;